module.exports = __webpack_public_path__ + "static/media/VestasSans-Bold.0fa5cf41.eot";